<div class="main_content bright">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <div class="page_main_sec">
        <div class="table_card_sec">
            <div class="row">
                <div class="col-lg-2 col-sm-4">
                    <mat-form-field appearance="legacy" [style.width.%]="100">
                        <mat-label for="module">Module</mat-label>
                        <mat-select [(ngModel)]="selectedModule" (selectionChange)="onSelectModule($event);"
                            id="module">
                            <mat-option [value]="option" *ngFor="let option of ModuleList">
                                {{option.module_name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-lg-5 col-sm-12">
                    <div class="browsefile_main_section">
                        <input [attr.type]="fileControlType" id="uploadFileName" (change)="onSelectFile($event)"
                            [disabled]="(selectedModule.module_id==undefined)" />
                        <div class="browse_file_sec">
                            <img src="../../../assets/img/transaction/cloud-upload-alt.png" alt="Browse File" />
                            <span>Drag & Drop Files</span>
                        </div>
                        <div class="browser_or_sec">
                            <span>Or</span>
                        </div>
                        <div class="browse_file_sec">
                            <img src="../../../assets/img/transaction/folder-open-solid.png" alt="Browse File" />
                            <span>Browse File</span>
                        </div>
                    </div>
                    <div class="files_note_sec">
                        <div *ngIf="this.selectedModule.extension" class="note">Only {{this.selectedModule.extension}}
                            file(s) are allowed.
                        </div>
                        <div class="files_uploaded_count">
                            {{attachmentList.length}} File is Uploaded. <span class="view_uploaded_doc"
                                (click)="isShowUploadedDocs = true">View Files</span>
                        </div>
                    </div>
                    <div class="uploaded_files_view_sec" *ngIf="isShowUploadedDocs">
                        <div class="uploaded_files_header">
                            <span>{{attachmentList.length}} files uploaded successfully.</span>
                            <span (click)="isShowUploadedDocs = false"><i class="material-icons"
                                    title="close">close</i></span>
                        </div>
                        <div class="files_list_sec">
                            <div class="file_status_sec" *ngFor="let file of attachmentList;let i=index">
                                <img src="../../../assets/img/transaction/file_uploaded.png" class="file_uploaded_icon"
                                    alt="File Upload">
                                <div class="file_name_sec">
                                    <div class="file_name_detail">
                                        <span class="status_file_name">{{file.name}}</span>
                                        <img (click)="deleteAttachment(i)"
                                            src="../../../assets/img/transaction/delete.png" title="delete"
                                            class="files_action_icon file_status_delete" alt="Delete">
                                    </div>
                                    <div class="file_status_bar"></div>
                                </div>
                                <span class="file_checked_icon">
                                    <img src="../../../assets/img/transaction/checked.png" alt="Transaction">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-5 col-sm-12">
                    <div class="row">
                        <div class="col-lg-12 text-right">
                            <button class="btncss" [class.btn_disable]="attachmentList.length==0"
                                [class.btn_primary]="attachmentList.length>0" [disabled]="attachmentList.length==0"
                                (click)="uploadFiles()">Upload Files</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <app-advance-gridview [lstData]="lstFiles" [lstHeaders]="lstHeaders" [gridTitle]="'Uploaded Files'"
                [showColumnGroup]="false" [showAdvanceSearchOption]="false" [showExcelDownloadOption]="true"
                [columnsToHide]="lstColumnsToHide">
            </app-advance-gridview>
        </div>
    </div>
</div>